import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ThemeToggle } from '../components/ThemeToggle';
import { useTheme } from '../contexts/ThemeContext';
import { apiClient } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import './Auth.css';

const ForgotPassword: React.FC = () => {
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState<{ type: 'success' | 'error', text: string } | null>(null);
  const { theme } = useTheme();

  const logoLarge = theme === 'dark'
    ? `${process.env.PUBLIC_URL}/debriefr_logo_text_dark.png`
    : `${process.env.PUBLIC_URL}/debriefr_logo_text_transparant.png`;

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setMessage(null);

    try {
      await apiClient.forgotPassword({ email });
      setMessage({
        type: 'success',
        text: 'If an account exists with this email, you will receive password reset instructions.'
      });
      setEmail('');
    } catch (error: any) {
      setMessage({
        type: 'error',
        text: error.response?.data?.detail || 'Failed to process request. Please try again.'
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="theme-toggle-container">
        <ThemeToggle />
      </div>
      <div className="auth-card">
        <div style={{ textAlign: 'center', marginBottom: '20px' }}>
          <img
            src={logoLarge}
            alt="Debriefr"
            style={{ width: '200px', maxWidth: '100%' }}
          />
        </div>
        <h1>Reset Your Password</h1>
        <p>Enter your email address and we'll send you a link to reset your password.</p>

        {message && (
          <div className={`alert alert-${message.type}`}>
            {message.text}
          </div>
        )}

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
              required
              placeholder="Enter your email address"
            />
          </div>

          <button type="submit" className="btn btn-primary btn-full" disabled={isLoading || !email.trim()}>
            {isLoading ? <LoadingSpinner size="sm" color="white" /> : 'Send Reset Link'}
          </button>
        </form>

        <div className="auth-footer">
          <p>Remember your password? <Link to="/login">Sign in</Link></p>
          <p>Don't have an account? <Link to="/signup">Sign up</Link></p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;